import { render, staticRenderFns } from "./addContestStudent.vue?vue&type=template&id=40fd908e&scoped=true"
import script from "./addContestStudent.vue?vue&type=script&lang=js"
export * from "./addContestStudent.vue?vue&type=script&lang=js"
import style0 from "./addContestStudent.vue?vue&type=style&index=0&id=40fd908e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd908e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40fd908e')) {
      api.createRecord('40fd908e', component.options)
    } else {
      api.reload('40fd908e', component.options)
    }
    module.hot.accept("./addContestStudent.vue?vue&type=template&id=40fd908e&scoped=true", function () {
      api.rerender('40fd908e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/addContestStudent.vue"
export default component.exports